import { configService } from "../index";
import Coupon from "../../models/coupon";
import { BaseRequests } from "./BaseRequests";
import { BaseRequestsInterface } from "./BaseRequests";

export default {
  ...BaseRequests(
    () => configService.coupon,
    "coupon",
    () => new Coupon()
  )
} as BaseRequestsInterface;
